import * as Types from '../../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RejectCommunityJoinInviteMutationVariables = Types.Exact<{
  inviteId: Types.Scalars['ID']['input'];
}>;


export type RejectCommunityJoinInviteMutation = { __typename?: 'Mutation', rejectJoinInvite: { __typename?: 'RejectJoinRequestPayload', communityGroupId: string } };


export const RejectCommunityJoinInviteDocument = gql`
    mutation RejectCommunityJoinInvite($inviteId: ID!) {
  rejectJoinInvite(data: {id: $inviteId}) {
    communityGroupId
  }
}
    `;
export type RejectCommunityJoinInviteMutationFn = Apollo.MutationFunction<RejectCommunityJoinInviteMutation, RejectCommunityJoinInviteMutationVariables>;

/**
 * __useRejectCommunityJoinInviteMutation__
 *
 * To run a mutation, you first call `useRejectCommunityJoinInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectCommunityJoinInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectCommunityJoinInviteMutation, { data, loading, error }] = useRejectCommunityJoinInviteMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useRejectCommunityJoinInviteMutation(baseOptions?: Apollo.MutationHookOptions<RejectCommunityJoinInviteMutation, RejectCommunityJoinInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectCommunityJoinInviteMutation, RejectCommunityJoinInviteMutationVariables>(RejectCommunityJoinInviteDocument, options);
      }
export type RejectCommunityJoinInviteMutationHookResult = ReturnType<typeof useRejectCommunityJoinInviteMutation>;
export type RejectCommunityJoinInviteMutationResult = Apollo.MutationResult<RejectCommunityJoinInviteMutation>;
export type RejectCommunityJoinInviteMutationOptions = Apollo.BaseMutationOptions<RejectCommunityJoinInviteMutation, RejectCommunityJoinInviteMutationVariables>;